<h6 class="prd-h6"> Facts </h6>
<p-toast [style]="{marginTop: '80px'}"></p-toast>
<p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>

<div class="card" >
    <div class="card-body" *ngIf = 'displayState.workingDiv'>    
        <div class="row" >
            <div class="col-md-12 alert alert-info" style="text-align: center"> Processing, please wait. </div>
        </div>
        <div class="row">
            <div class="col-md-2 offset-5">
                <!-- <p-progressSpinner [style]="{width: '100px', height: '100px', margin: '60px'}" strokeWidth="1" fill="#EEEEEE" animationDuration="2.2s"></p-progressSpinner> -->
            </div>
        </div>
    </div>
</div>
<br />

<div class="row" *ngIf='!this.displayState.factDiv' >
  <div class="col-md-2 offset-1">
      <button class="btn btn-sm btn-link" (click)="newFact()">New Fact</button>
  </div>
</div>

<div class="row" *ngIf = 'displayState.gridDiv'>
  <div class="col-md-10 offset-1">
    <p-table [value]="factList" [scrollable]="true" scrollHeight="540px"  >
      <ng-template pTemplate="header">
          <tr style="font-size:smaller">
              <th style="width: 10%" >&nbsp;</th>
              <th [pSortableColumn]="'letter'" style="width: 10%" >
                  Letter
                  <p-sortIcon [field]="'letter'"></p-sortIcon>
              </th>
              <th style="width: 45%">
                  Fact
              </th>
              <th style="width: 10%" >&nbsp;</th>
          </tr>
      </ng-template>
      <ng-template pTemplate="body" let-fact>
          <tr style="font-size: small;">
              <td style="width: 10%">
                  <button class='btn btn-sm btn-link' (click)="onSelect(fact)">Select</button>
              </td>
              <td style="width: 10%">{{fact.letter }}</td>
              <td style="width: 45%">{{fact.fact}}</td>    
              <td style="width: 10%">
                <button class='btn btn-sm btn-link' (click)="deleteFact(fact)" [disabled]="userType === 'Read-Only' || userType === 'Appraiser'">Delete</button>
            </td>

          </tr>
      </ng-template>
      <ng-template pTemplate="summary">
        <div class="row">
            <div class="col-md-2" style="text-align: left;"># of items: {{ factList?.length }}</div>
        </div>
      </ng-template>

    </p-table>
  </div>
</div>

<div class="row" *ngIf='displayState.editFactDiv'>
    <div class="card bg-light col-md-6 offset-3">
        <div class="card-body">
            <div class="form-row">
                <label for="code" class="col-md-2 col-form-label prd-label">Letter Code</label>
                <input type="text" class="form-control col-md-8 prd-required" id="code" [(ngModel)]="myFact.letter">
            </div>
            <br />
           <div class="form-row">
                <!-- Fact text -->
                <label for="factText" class="col-md-2 col-form-label prd-label">Fact Text</label>
                <textarea class="form-control col-md-8 prd-required" id="factText" [(ngModel)]="myFact.fact"></textarea>
            </div>
            <br />
            <div class="form-row">
                <!-- Buttons -->
                <button class="btn btn-success offset-3" (click)="saveFact()" [disabled] = "displayState.saveDisabled" >Save</button>
                <button class="btn btn-warning offset-1" (click)="cancelEntry()">Cancel</button>
            </div>
        </div>
    </div>
</div>
